import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type RemovePartnerUserInput = {
  partnerId: string;
  partnerUserId: string;
};

// DELETE /api/partners/:id/users/:userId
//
// Ports removePartnerUser from /app/admin/partners/[id]/_actions.ts.
// The partner_users -> invites FK uses ON DELETE CASCADE (migration
// 0013_invites.sql), so pending invite rows drop alongside the partner_user.
export function useRemovePartnerUser() {
  const queryClient = useQueryClient();
  return useMutation<{ ok: true }, ApiClientError, RemovePartnerUserInput>({
    mutationFn: ({ partnerId, partnerUserId }) =>
      apiFetch<{ ok: true }>(`/partners/${partnerId}/users/${partnerUserId}`, {
        method: "DELETE",
      }),
    onSuccess: (_data, { partnerId }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.partners.users(partnerId) });
      queryClient.invalidateQueries({ queryKey: queryKeys.partners.detail(partnerId) });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to remove contact");
    },
  });
}
